import { t } from 'ttag';

const RUN_DISABLED_MODULES = new Set(['tnc_conservation']);

export function isAnalysisModuleRunDeprecated(moduleKey?: string): boolean {
  return !!moduleKey && RUN_DISABLED_MODULES.has(moduleKey);
}

export function getDeprecatedAnalysisModuleStatusMessage(
  moduleKey?: string,
): string | undefined {
  if (!isAnalysisModuleRunDeprecated(moduleKey)) {
    return undefined;
  }

  return t`Deprecated. Existing results remain available.`;
}
